const notAuthenticatedAdmin = ({ store, redirect }) => {
  // If the user is authenticated redirect to home page
  if (store.state.auth.isAuthenticatedAdmin) {
    return redirect('/admin');
  }
};

export default notAuthenticatedAdmin;
